<main>
    <div [class]="!isCollapsed ? 'dashboard-container' : 'dashboard-container collapsed'">
        <div class="tenant-header">
            <dealer-tenant-header></dealer-tenant-header>
        </div>
        <div class="user-header">
            <dealer-user-header></dealer-user-header>
        </div>
        <div class="content">
            <system-message-banner></system-message-banner>
            <breadcrumb *ngIf="!hideBreadcrumbs" (outEvent)="eventHandler($event)"></breadcrumb>
            <div class="display-help">
                <need-help-panel *ngIf="helpPanel$ | async">
                    <ng-container [ngTemplateOutlet]="helpPanel$ | async"></ng-container>
                </need-help-panel>
            </div>
            <router-outlet></router-outlet>
            <div class="footer" [class.signing]="hideFooter">
                <app-footer></app-footer>
            </div>
        </div>

        <div class="side-nav">
            <dealer-side-nav></dealer-side-nav>
        </div>
    </div>
</main>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
